import React from 'react'
import { array, object, func } from 'prop-types'

import { Button } from 'react-bootstrap'

import QueryEditor from 'coact/QueryEditor'

import style from './style'

function Filter (props) {
  const { query, setQuery, fields, schema, download, downloadToday } = props
  return (
    <div>
      <h3 className={style.pageTitle}>銷貨單明細下載</h3>
      <div>
        <div style={{ marginTop: 20, marginBottom: 80 }}>
          <Button bsStyle="success" onClick={downloadToday}>下載今日明細</Button>
        </div>
        <h4 className={style.pageTitle} style={{ marginBottom: 5 }}>設定條件</h4>
        <QueryEditor
          {...{
            value: query,
            onChange: setQuery,
            fields,
            schema,
          }}
        />
        {/* <List {...spliter(props, 'billDate')} />
        <List {...spliter(props, 'customerGroupRef')} />
        <List {...spliter(props, 'customerRef')} /> */}
        <div>
          <Button bsStyle="primary" onClick={download}>下載</Button>
        </div>
      </div>
    </div>
  )
}
Filter.propTypes = {
  query: object.isRequired,
  setQuery: func.isRequired,
  fields: array.isRequired,
  schema: object.isRequired,

  download: func.isRequired,
  downloadToday: func.isRequired,
}

module.exports = Filter



// WEBPACK FOOTER //
// ./src/components/SalesOrderDetail/Filter.jsx